import useFetch from 'utils/hooks/useFetch'
import { ApiCreateTenantAccessKey, ApiDeleteTenant, ApiGetBookingTenantList, ApiGetTenant, ApiInsertTenant, ApiUpdateTenant } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function TenantService() {
    const { showFail } = useModal()

    const { fetch: apiInsertTenant } = useFetch(ApiInsertTenant)
    const { fetch: apiUpdateTenant } = useFetch(ApiUpdateTenant)
    const { fetch: apiDeleteTenant } = useFetch(ApiDeleteTenant)
    const { fetch: apiGetTenantById } = useFetch(ApiGetTenant)
    const { fetch: apiGetTenantList } = useFetch(ApiGetBookingTenantList)
    const { fetch: apiCreateTenantAccessKey } = useFetch(ApiCreateTenantAccessKey)
 
    const fetchCreateTenant = async (
        tenantName, 
        gender, 
        idNumber, 
        placeOfBirth, 
        dateOfBirth, 
        address, 
        city, 
        province, 
        country, 
        phone, 
        photoID, 
        workPlace, 
        vehicle, 
        vehicleBrand,
        vehicleModel,
        licensePlate, 
        contactName, 
        contactPhone,
        contactRelation
    ) => {
        let data = new FormData()

        data.append('tenantName', tenantName)
        data.append('gender', gender)
        data.append('idNumber', idNumber)
        data.append('placeOfBirth', placeOfBirth)
        data.append('dateOfBirth', dateOfBirth)
        data.append('address', address)
        data.append('city', city)
        data.append('province', province)
        data.append('country', country)
        data.append('phone', phone)
        data.append('photoID', photoID)
        data.append('workPlace', workPlace)
        data.append('vehicle', vehicle)
        data.append('vehicleBrand', vehicleBrand)
        data.append('vehicleModel', vehicleModel)
        data.append('licensePlate', licensePlate)
        data.append('contactName', contactName)
        data.append('contactPhone', contactPhone)
        data.append('contactRelation', contactRelation)

        const res = await apiInsertTenant({
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateTenant = async (
        tenantId, 
        tenantName, 
        gender, 
        idNumber, 
        placeOfBirth, 
        dateOfBirth, 
        address, 
        city, 
        province, 
        country, 
        phone, 
        photoID, 
        workPlace, 
        vehicle, 
        vehicleBrand,
        vehicleModel,
        licensePlate, 
        contactName, 
        contactPhone,
        contactRelation
    ) => {
        let data = new FormData()

        data.append('tenantId', tenantId)
        data.append('tenantName', tenantName)
        data.append('gender', gender)
        data.append('idNumber', idNumber)
        data.append('placeOfBirth', placeOfBirth)
        data.append('dateOfBirth', dateOfBirth)
        data.append('address', address)
        data.append('city', city)
        data.append('province', province)
        data.append('country', country)
        data.append('phone', phone)
        data.append('photoID', photoID)
        data.append('workPlace', workPlace)
        data.append('vehicle', vehicle)
        data.append('vehicleBrand', vehicleBrand)
        data.append('vehicleModel', vehicleModel)
        data.append('licensePlate', licensePlate)
        data.append('contactName', contactName)
        data.append('contactPhone', contactPhone)
        data.append('contactRelation', contactRelation)

        const res = await apiUpdateTenant({
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteTenant = async (tenantId, status) => {
        const res = await apiDeleteTenant({
            data: {
                tenantId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchTenantById = async (tenantId) => {
        const res = await apiGetTenantById({
            data: {
                tenantId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchTenantList = async (tenantName, phone, status, pageSize, pageIndex) => {
        const res = await apiGetTenantList({
            data: {
                tenantName,
                phone,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateTenantAccessKey = async () => {
        const res = await apiCreateTenantAccessKey({
            data: { }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchCreateTenant,
        fetchUpdateTenant,
        fetchTenantById,
        fetchTenantList,
        fetchDeleteTenant,
        fetchCreateTenantAccessKey
    }
}